import Component from '@glimmer/component';

import { InHead } from 'ember-primitives/head';

export default class SsrSupportInHead extends Component {
  constructor() {
    super(...arguments);
    this.tearDownHead();
  }

  tearDownHead() {
    if (this.isSsr) {
      return;
    }
    const startMeta = document.querySelector('meta[name="ssr-head-start"]');
    const endMeta = document.querySelector('meta[name="ssr-head-end"]');
    if (!(startMeta && endMeta)) {
      return;
    }
    let el, next = startMeta;
    do {
      el = next;
      next = el.nextSibling;
      el.remove();
    } while (next && el !== endMeta);
  }

  isSsr = !!globalThis.Ssr;

  <template>
    <InHead>
      {{#if this.isSsr}}<meta name="ssr-head-start" content>{{/if}}
      {{yield}}
      {{#if this.isSsr}}<meta name="ssr-head-end" content>{{/if}}
    </InHead>
  </template>
}
